import React from "react";
import moment from "moment";
import { XIcon } from "lucide-react";
import CustomButton from "../../../../custom/custom-button/CustomButton";
import style from "./CanceledOrderCard.module.scss";

const noop = () => undefined;

const CanceledOrderCard = ({ canceledStatus, emptyReasonText = "", onFindNewOrders = noop }) => {
  const canceledAt = canceledStatus?.createdAt
    ? moment(canceledStatus.createdAt).format("DD.MM.YYYY, HH:mm")
    : "";
  const reason = canceledStatus?.comment?.trim() || emptyReasonText;

  return (
    <section className={style.card} data-testid="canceled-order-card">
      <div className={style.icon} aria-hidden="true">
        <XIcon size={54} strokeWidth={6} strokeLinecap="square" />
      </div>

      <div className={style.text_group}>
        <h3 className={style.title}>Заказ отменен партнёром</h3>
        {canceledAt && <p className={style.date}>Отменено: {canceledAt}</p>}
      </div>

      {reason && <p className={style.reason}>Причина: {reason}</p>}

      <div className={style.action}>
        <CustomButton text="Найти новые заказы" isNavy onClick={onFindNewOrders} />
      </div>
    </section>
  );
};

export default CanceledOrderCard;
